var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStopwatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.692,
    height: 82,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffba60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.365 18.864a1.582 1.582 0 0 0 2.227 0l2.227-2.227a1.582 1.582 0 0 0 0-2.227l-5.026-5.026a1.582 1.582 0 0 0-2.227 0l-2.227 2.226a1.582 1.582 0 0 0 0 2.227l5.026 5.026zm-65.265 0a1.582 1.582 0 0 0 2.227 0l5.026-5.026a1.582 1.582 0 0 0 0-2.227L9.126 9.384a1.582 1.582 0 0 0-2.227 0l-5.027 5.005a1.582 1.582 0 0 0 0 2.227z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.577 6.6V3.15A3.163 3.163 0 0 0 39.423 0h-3.154a3.163 3.163 0 0 0-3.154 3.154V6.6a37.846 37.846 0 1 0 9.462 0zm-1.971 43.227v3.785a2.76 2.76 0 1 1-5.519 0v-3.781a6.316 6.316 0 0 1 0-11.354V18.923a2.76 2.76 0 0 1 5.519 0v19.554a6.316 6.316 0 0 1 0 11.354z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.db25634f5d8e1ea618b6179d4a92a4cf.svg";
export { ForwardRef as ReactComponent };